import mascotNoData from "../../Assets/icons/okkali_mascot_nodata.png";

export default function EmptyState({
  message = "Sonuç bulunamadı",
  suggestion,
}) {
  return (
    <div className="flex flex-col items-center justify-center py-10 sm:py-16 px-4 text-center select-none">
      <img
        src={mascotNoData}
        alt="Veri bulunamadı"
        className="w-28 h-28 sm:w-36 sm:h-36 md:w-44 md:h-44 object-contain mb-4 sm:mb-6 drop-shadow-lg"
        draggable={false}
      />
      <h3 className="text-base sm:text-lg md:text-xl font-bold text-gray-700 mb-1">
        {message}
      </h3>
      {suggestion && (
        <p className="text-sm sm:text-base text-gray-400 mt-1 max-w-sm">
          {suggestion}
        </p>
      )}
    </div>
  );
}
